module.exports = __webpack_public_path__ + "img/contacts.25cabb35.svg";